import { render, staticRenderFns } from "./just-try.vue?vue&type=template&id=addf6bbc"
import script from "./just-try.vue?vue&type=script&lang=js"
export * from "./just-try.vue?vue&type=script&lang=js"
import style0 from "./just-try.vue?vue&type=style&index=0&id=addf6bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports